import React, { useState } from "react";
import HomeSearch from "./elements/HomeSearch";

import searchIcon from "../assets/images/blue.svg";
import { Link, useNavigate } from "react-router-dom";
import back from "../assets/images/leftArrow.svg";

const MobileHeaderSearch = ({ text = false, headingtext = "sample", to, onSearch = () => {}, ...props }) => {
  const [search, setSearch] = useState('')
  const navigate = useNavigate()

  return (
    <>
      {!text && (
        <div className="d-flex justify-content-between align-items-center w-100 mx-4">
          <div className="bg-info me-2 rounded-circle p-1" style={{ width: "40px", height: "40px" }} onClick={() => navigate(-1)}>
            <img src={back} alt="" className="w-100" />
          </div>

          <div className="search-bar-container">
            <div className="search-input-wrapper">
              
              <span className="search-icon d-flex">
                <img src={searchIcon} alt="" />
              </span>

              <input
                type="text"
                className="search-input"
                value={search}
                onChange={e => setSearch(e.target.value) }
                onKeyDown={e =>  (e.key === "Enter" && e.keyCode === 13) && (onSearch(search), setSearch("")) }
                { ...props }
              />

              {
                to
                ?<Link to={to} className="search-button fs-8 px-4">Search</Link>
                : <button className="search-button"  onClick={() => (setSearch(""), onSearch(search))}>Search</button>
              }

            </div>
          </div>
        </div>
      )}

      {text && (
        <div className="d-flex gap-3 justify-content-start w-100 px-4">
          <div className="bg-info me-2 rounded-circle p-1" style={{ width: "40px", height: "40px" }} onClick={() => navigate(-1)}>
            <img src={back} alt="" className="w-100" />
          </div>
          <div className="text-light fs-1 fw-bold">{headingtext}</div>
        </div>
      )}
    </>
  );
};

export default MobileHeaderSearch;
